var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH5AndApplet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.33554,
    y: -0.142671,
    width: 14.3825,
    height: 16.5632
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.17px)",
      clipPath: "url(#bgblur_0_9308_7514_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.33579,
    d: "M4.85571 10.0271C2.22284 10.0271 0.000594139 10.4454 0.000244141 12.0632C0.000244141 13.6802 2.23685 14.0847 4.85571 14.0847C7.48863 14.0847 9.71103 13.6666 9.71118 12.0486C9.71118 10.4317 7.4745 10.0271 4.85571 10.0271ZM4.85571 2.19312C3.0721 2.19312 1.64282 3.59289 1.64282 5.3396C1.64283 7.08631 3.0721 8.48608 4.85571 8.48608C6.63862 8.48601 8.0686 7.08627 8.0686 5.3396C8.0686 3.59293 6.63862 2.19319 4.85571 2.19312Z",
    fill: "url(#paint0_linear_9308_7514)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9308_7514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91023 11.0642C7.50919 11.0642 8.87488 11.3329 8.87488 12.4067C8.87488 13.4814 7.51787 13.7593 5.91023 13.7593C4.31126 13.7593 2.94558 13.4907 2.94558 12.4168C2.94558 11.3421 4.30258 11.0642 5.91023 11.0642Z",
    fill: "#EF5641",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_9308_7514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64073 6.93168C4.74304 6.93168 4.02365 6.21229 4.02365 5.31459C4.02365 4.4169 4.74304 3.69751 5.64073 3.69751C6.5381 3.69751 7.25781 4.4169 7.25781 5.31459C7.25781 6.21229 6.5381 6.93168 5.64073 6.93168Z",
    fill: "#EF5641",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.389823,
    y: -1.87483,
    width: 18.485,
    height: 21.3454
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.35px)",
      clipPath: "url(#bgblur_1_9308_7514_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.69514
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_9308_7514",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 14,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    width: 14,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63184 11.2744C6.17881 11.2744 3.26465 11.8232 3.26465 13.9453C3.26492 16.0655 6.19762 16.5957 9.63184 16.5957C13.085 16.5957 16 16.047 16 13.9248C15.9997 11.8045 13.0662 11.2744 9.63184 11.2744ZM9.63184 1C7.29301 1.00014 5.4192 2.83557 5.41895 5.12598C5.41895 7.4166 7.29285 9.25279 9.63184 9.25293C11.9701 9.25293 13.8457 7.41669 13.8457 5.12598C13.8454 2.83548 11.9699 1 9.63184 1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.63184 11.2744C6.17881 11.2744 3.26465 11.8232 3.26465 13.9453C3.26492 16.0655 6.19762 16.5957 9.63184 16.5957C13.085 16.5957 16 16.047 16 13.9248C15.9997 11.8045 13.0662 11.2744 9.63184 11.2744ZM9.63184 1C7.29301 1.00014 5.4192 2.83557 5.41895 5.12598C5.41895 7.4166 7.29285 9.25279 9.63184 9.25293C11.9701 9.25293 13.8457 7.41669 13.8457 5.12598C13.8454 2.83548 11.9699 1 9.63184 1Z",
    fill: "#FFBC00",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63184 11.2744L9.63183 11.0947H9.63184V11.2744ZM3.26465 13.9453L3.08497 13.9453V13.9453H3.26465ZM9.63184 16.5957V16.7754H9.63183L9.63184 16.5957ZM16 13.9248L16.1797 13.9248V13.9248H16ZM9.63184 1L9.63182 0.820324H9.63184V1ZM5.41895 5.12598H5.23927V5.12596L5.41895 5.12598ZM9.63184 9.25293V9.43261H9.63182L9.63184 9.25293ZM13.8457 5.12598L14.0254 5.12596V5.12598H13.8457ZM9.63184 11.2744L9.63184 11.4541C7.90954 11.4541 6.34278 11.5917 5.21224 11.9838C4.64805 12.1795 4.20538 12.4344 3.90518 12.7554C3.6089 13.0723 3.44432 13.4607 3.44432 13.9453H3.26465H3.08497C3.08497 13.3689 3.28466 12.8929 3.6427 12.51C3.99681 12.1313 4.4985 11.8511 5.09447 11.6443C6.28428 11.2316 7.90111 11.0948 9.63183 11.0947L9.63184 11.2744ZM3.26465 13.9453L3.44432 13.9453C3.44439 14.429 3.60986 14.8157 3.9073 15.1305C4.20881 15.4496 4.65314 15.7022 5.21865 15.8956C6.35174 16.2831 7.91866 16.416 9.63184 16.416L9.63184 16.5957L9.63183 16.7754C7.9108 16.7754 6.29425 16.6432 5.10237 16.2356C4.50539 16.0314 4.00187 15.7539 3.64609 15.3773C3.28626 14.9964 3.08505 14.5217 3.08497 13.9453L3.26465 13.9453ZM9.63184 16.5957V16.416C11.3542 16.416 12.9212 16.2785 14.052 15.8863C14.6163 15.6906 15.0591 15.4357 15.3593 15.1147C15.6557 14.7978 15.8203 14.4094 15.8203 13.9248H16H16.1797C16.1797 14.5013 15.9799 14.9773 15.6218 15.3602C15.2676 15.7389 14.7658 16.0191 14.1697 16.2258C12.9797 16.6386 11.3626 16.7754 9.63184 16.7754V16.5957ZM16 13.9248L15.8203 13.9248C15.8203 13.4411 15.6547 13.0545 15.3572 12.7396C15.0556 12.4205 14.6112 12.1679 14.0456 11.9745C12.9122 11.587 11.3451 11.4541 9.63184 11.4541V11.2744V11.0947C11.3529 11.0947 12.9697 11.2269 14.1618 11.6345C14.7589 11.8387 15.2625 12.1162 15.6184 12.4928C15.9783 12.8737 16.1796 13.3484 16.1797 13.9248L16 13.9248ZM9.63184 1L9.63185 1.17968C7.38871 1.17981 5.59886 2.9383 5.59862 5.126L5.41895 5.12598L5.23927 5.12596C5.23954 2.73283 7.19731 0.820472 9.63182 0.820324L9.63184 1ZM5.41895 5.12598H5.59862C5.59862 7.31391 7.38859 9.07312 9.63185 9.07325L9.63184 9.25293L9.63182 9.43261C7.19712 9.43246 5.23927 7.5193 5.23927 5.12598H5.41895ZM9.63184 9.25293V9.07325C11.8744 9.07325 13.666 7.31393 13.666 5.12598H13.8457H14.0254C14.0254 7.51946 12.0658 9.43261 9.63184 9.43261V9.25293ZM13.8457 5.12598L13.666 5.126C13.6658 2.93828 11.8743 1.17968 9.63184 1.17968V1V0.820324C12.0656 0.820324 14.0251 2.73268 14.0254 5.12596L13.8457 5.12598Z",
    fill: "url(#paint1_linear_9308_7514)",
    mask: "url(#path-4-outside-1_9308_7514)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7514_clip_path",
    transform: "translate(2.33554 0.142671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85571 10.0271C2.22284 10.0271 0.000594139 10.4454 0.000244141 12.0632C0.000244141 13.6802 2.23685 14.0847 4.85571 14.0847C7.48863 14.0847 9.71103 13.6666 9.71118 12.0486C9.71118 10.4317 7.4745 10.0271 4.85571 10.0271ZM4.85571 2.19312C3.0721 2.19312 1.64282 3.59289 1.64282 5.3396C1.64283 7.08631 3.0721 8.48608 4.85571 8.48608C6.63862 8.48601 8.0686 7.08627 8.0686 5.3396C8.0686 3.59293 6.63862 2.19319 4.85571 2.19312Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9308_7514",
    x: 0.60977,
    y: 8.72842,
    width: 10.6009,
    height: 7.36664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16789,
    result: "effect1_foregroundBlur_9308_7514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_9308_7514",
    x: 1.32854,
    y: 1.00237,
    width: 8.62441,
    height: 8.62441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.34757,
    result: "effect1_foregroundBlur_9308_7514"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7514_clip_path",
    transform: "translate(-0.389823 1.87483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63184 11.2744C6.17881 11.2744 3.26465 11.8232 3.26465 13.9453C3.26492 16.0655 6.19762 16.5957 9.63184 16.5957C13.085 16.5957 16 16.047 16 13.9248C15.9997 11.8045 13.0662 11.2744 9.63184 11.2744ZM9.63184 1C7.29301 1.00014 5.4192 2.83557 5.41895 5.12598C5.41895 7.4166 7.29285 9.25279 9.63184 9.25293C11.9701 9.25293 13.8457 7.41669 13.8457 5.12598C13.8454 2.83548 11.9699 1 9.63184 1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7514",
    x1: 4.1408,
    y1: 8.93523,
    x2: 13.2542,
    y2: 12.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7514",
    x1: 13.9727,
    y1: 2.81692,
    x2: 3.79649,
    y2: 13.1089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH5AndApplet);
export default __webpack_public_path__ + "static/media/h5AndApplet.557a9ddc09b2b5e5b6f5ec0aec1c8ca3.svg";
export { ForwardRef as ReactComponent };